import React, { Component } from "react";
import Select from "react-select";

class VariantSelector extends Component {
  render() {
    var colourOptions = [];

    this.props.option.values.map((value) => {
      colourOptions.push({
        value: `${value}`,
        label: `${value}`,
      });
      return true;
    });

    var field_Name = this.props.fieldName

    if (field_Name === "Size") {
      return (
        <div className="color_select">      
          <div class="swatch size clearfix" data-option-index="2">
            <div class="header">
              <span>Size</span>
            </div>
            <div>
                {colourOptions.map(ss => {
                  let size_no = this.props.variants.filter(tt => tt.title.includes(ss.value));
                  if(size_no.length > 0) {
                    size_no = size_no.filter(ttt => ttt.available);
                  }
                  if(size_no && size_no.length > 0) 
                  {
                    return (
                      <div data-value="28" class='swatch-element 28 available'>
                        <input id="swatch-2-28" type="radio" name="option-2" value="28" onClick={(e) => this.props.handleOptionChange({value: ss.value}, field_Name)}/>
                        <label for="swatch-2-28">
                          {ss.label}
                        </label>
                      </div>
                    )
                  }
                  else
                  {
                    return (
                      <div data-value="28" class='swatch-element 28 soldout'>
                        <input id="swatch-2-28" type="radio" name="option-2" value="28" disabled="disabled"/>
                        <label for="swatch-2-28">
                          {ss.label}
                        </label>
                      </div>
                    )
                  }
                  return true
                })}
              </div>
          </div>

        </div>
      );
    }
    else if (field_Name === "Dimension") {
      return (
        <div className="color_select">
          <label for="product-select-option-0">Dimension</label>
          <Select
            className="basic-single"
            classNamePrefix="select"
            name={this.props.fieldName}
            defaultValue={colourOptions[0]}
            options={colourOptions}
            onChange={(e) => this.props.handleOptionChange(e, field_Name)}
            value={this.props.selectedDimensionValue && colourOptions.filter(
              ({ value }) => value === this.props.selectedDimensionValue
            )}
          />
        </div>
      );
    }
    else {
      return (
        <div className="color_select">
          <label for="product-select-option-1">Color</label>
          <Select
            className="basic-single"
            classNamePrefix="select"
            name={this.props.fieldName}
            defaultValue={colourOptions[0]}
            options={colourOptions}
            onChange={(e) => this.props.handleOptionChange(e, field_Name)}
            value={this.props.selectedColorValue && colourOptions.filter(
              ({ value }) => value === this.props.selectedColorValue
            )}
          />
        </div>
      );
    }
  }
}

export default VariantSelector;


// WEBPACK FOOTER //
// ./src/components/VariantSelector.js